import actionCreatorFactory from 'typescript-fsa';

import * as api from '../api';
import * as store from './store';
import { transformFormSets } from './transformer';

const actionCreator = actionCreatorFactory();

type SetFormSetsAction = {
  formSets: api.PrevisitFormSet.PrevisitFromSetWithPatientData[];
};

export const setFormSets = actionCreator<SetFormSetsAction>(
  'SET_FORM_SETS_DETAILS',
);
export function setFormSetsHandler(
  state: store.All,
  payload: SetFormSetsAction,
): store.All {
  const formSets = transformFormSets(payload.formSets);
  const masterPracticePreference =
    Object.values(formSets)[0]?.practicePreference;

  return {
    ...state,
    formSets,
    masterPracticePreference,
  };
}

type FeedbackAction = store.PatientFeedback | null;
export const setPatientFeedback = actionCreator<FeedbackAction>(
  'SET_PATIENT_FEEDBACK',
);
export function setPatientFeedbackHandler(
  state: store.All,
  patientFeedback: FeedbackAction,
): store.All {
  return {
    ...state,
    patientFeedback,
  };
}

export const setSelectedFormSetId = actionCreator<string | null>(
  'SET_SELECTED_FORM_SET_ID',
);
export function setSelectedFormSetIdHandler(
  state: store.All,
  selectedFormSetId: string | null,
): store.All {
  return {
    ...state,
    selectedFormSetId,
  };
}

export const setMultiFormSet = actionCreator<boolean>('SET_MULTI_FORM_SET');
export function setMultiFormSetHandler(
  state: store.All,
  multiFormSet: boolean,
): store.All {
  return {
    ...state,
    multiFormSet,
  };
}
